import { render, staticRenderFns } from "./IsometricView.vue?vue&type=template&id=2afc9128&scoped=true"
import script from "./IsometricView.vue?vue&type=script&lang=js"
export * from "./IsometricView.vue?vue&type=script&lang=js"
import style0 from "./IsometricView.vue?vue&type=style&index=0&id=2afc9128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afc9128",
  null
  
)

export default component.exports